import { useWindowSize } from "@components/window-size-provider";
import useHasPermission from "@hooks/useHasPermission";
import { IssueFilters } from "@mwServices/Issue";
import { Button, Col, Drawer, Row } from "antd";
import { ReactElement, useEffect, useState } from "react";

export interface GeneralDrawerProps {
    title?: any,
    renderFooter?: any,
    children?: ReactElement[];
}

export const defaultIssueFilterProps: GeneralDrawerProps = {}

const GeneralDrawer = ({
    title,
    renderFooter,
    visible,
    onClose,
    children
}) => {
    const windowDimensions = useWindowSize();
    const [drawerWidth, setDrawerWidth] = useState(450);
    const isAdmin = useHasPermission('admin');

    useEffect(() => {
        const newWidth = (windowDimensions.width < 450)
            ? windowDimensions.width
            : 450;

        if (newWidth !== drawerWidth) setDrawerWidth(newWidth);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windowDimensions]);

    return (
        <Drawer
            title={title}
            className="general-drawer"
            headerStyle={{
                paddingTop: isAdmin
                    ? 50
                    : 16
            }}
            width={drawerWidth}
            placement="right"
            open={visible}
            onClose={onClose}
            footer={renderFooter}>
            {children}
        </Drawer>
    );
};

GeneralDrawer.defaultProps = defaultIssueFilterProps;

export default GeneralDrawer;